import { EditablePreviewEnabled } from 'devexpress-reporting/viewer/settings';

/**
 * DevExpress düzenlenebilir önizleme (editing fields) global bir ayardır
 * (`EditablePreviewEnabled`, varsayılan: false). Aynı SPA oturumunda hem editable
 * (ticket create) hem read-only (ticket detay / onay / my-work report tab) viewer'lar
 * mount olabildiğinden, istenen değer mode'a göre sayaçlarla çözülür.
 *
 * Çözüm önceliği:
 *  - editable viewer aktifse  -> true
 *  - yoksa read-only aktifse   -> false
 *  - hiçbiri yoksa             -> baseline (ilk yönetilen viewer öncesi global değer)
 */

let baseline = null;
let readOnlyCount = 0;
let editableCount = 0;

function captureBaseline() {
    if (baseline === null) {
        baseline = EditablePreviewEnabled();
    }
}

function applyDesired() {
    if (editableCount > 0) {
        EditablePreviewEnabled(true);
        return;
    }
    if (readOnlyCount > 0) {
        EditablePreviewEnabled(false);
        return;
    }
    if (baseline !== null) {
        EditablePreviewEnabled(baseline);
        baseline = null;
    }
}

/**
 * Read-only viewer mount edilmeden önce çağrılır (editing fields kapalı).
 * İç içe / Strict Mode için sayaçlı.
 */
export function enterReadOnlyReportPreview() {
    captureBaseline();
    readOnlyCount += 1;
    applyDesired();
}

export function leaveReadOnlyReportPreview() {
    readOnlyCount = Math.max(0, readOnlyCount - 1);
    applyDesired();
}

/**
 * Editable viewer (ör. ticket create) mount edilmeden önce çağrılır (editing fields açık).
 */
export function enterEditableReportPreview() {
    captureBaseline();
    editableCount += 1;
    applyDesired();
}

export function leaveEditableReportPreview() {
    editableCount = Math.max(0, editableCount - 1);
    applyDesired();
}
